/* eslint-disable */
import after_service from './hymns/after_service.pdf';
import after_text from './hymns/after_text.pdf';
import before_service1 from './hymns/before_service1.pdf';
import before_service2 from './hymns/before_service2.pdf';
import before_service3 from './hymns/before_service3.pdf';
import calling_up1 from './hymns/calling_up1.pdf';
import calling_up2 from './hymns/calling_up2.pdf';
import communion1 from './hymns/communion1.pdf';
import communion2 from './hymns/communion2.pdf';
import opening_service from './hymns/opening_service.pdf';
import prep_departed from './hymns/prep_departed.pdf';
import repentance from './hymns/repentance.pdf';
import theme_song from './hymns/theme_song.pdf';
import ypic_cg_2018 from './docs/ypic-cg-2018.pdf';

export default {
  after_service,
  after_text,
  before_service1,
  before_service2,
  before_service3,
  calling_up1,
  calling_up2,
  communion1,
  communion2,
  opening_service,
  prep_departed,
  repentance,
  theme_song,
  ypic_cg_2018,
};



// WEBPACK FOOTER //
// ./src/assets/pdfs/index.js